
const easeInOut = ({ elapsedTime, start, end, duration }) => {
  const change = end - start;
  elapsedTime /= duration / 2;
  if (elapsedTime < 1) {
    return change / 2 * elapsedTime * elapsedTime + start;
  }
  elapsedTime -= 1;
  return -change / 2 * (elapsedTime * (elapsedTime - 2) - 1) + start;
};

const animate = (options) => {
  const { duration, increment, el } = options;
  options.elapsedTime += increment;
  el.scrollTop = easeInOut(options);
  if (options.elapsedTime < duration) {
    setTimeout(function () {
      animate(options);
    }, increment);
  }
};

export const scrollTo = (el, options = {}) => {
  options = Object.assign({}, {
    el,
    duration: 500,
    elapsedTime: 0,
    start: options.startBottom ? el.scrollHeight : el.scrollTop,
    end: el.scrollHeight,
    increment: 20,
  }, options);

  animate(options);
};
